module.exports = __webpack_public_path__ + "img/xz.0fee57d2.jpg";